const AUTH_URL = 'https://medi4u.co.za/mobile/symptoms/api/checker.php?type=1';
const API_URL = 'https://healthservice.priaid.ch/';
const LANGUAGE = 'en-gb';


export default {
  Constants: {
    TYPES: {
      man: 'Man',
      woman: 'Woman',
      boy: 'Body',
      girl: 'Girl'
    }
  },
  token: null,
  loadToken(callback) {
    var self = this;

    if (self.token !== null) {
      return new Promise(function (resolve, error) {
        resolve();
      });
    }

    const myRequest = new Request(AUTH_URL);

    return fetch(myRequest).then(function (response) {
      var json = response.json();
      return json;
    }).then(function (json) {
      self.token = json.token;
      return json;
    }).catch(function (error) {
      console.log(error);
    });
  },
  loadInitialSymptoms(locationId, personType) {
    var self = this;
    return this.loadToken().then(function () {
      return self.fetch('symptoms/' + locationId + '/' + personType, {});
    })
  },
  loadDiagnosis(symptoms, gender, yearOfBirth) {
    var self = this;
    return this.loadToken().then(function () {
      return self.fetch('diagnosis', {
        symptoms: '[' + symptoms.toString() + ']',
        gender: gender,
        year_of_birth: yearOfBirth
      });
    })
  },
  loadProposedSymptoms(symptoms, gender, yearOfBirth) {
    var self = this;
    return this.loadToken().then(function () {
      return self.fetch('symptoms/proposed', {
        symptoms: '[' + symptoms.toString() + ']',
        gender: gender,
        year_of_birth: yearOfBirth
      });
    })
  },
  loadIssueInfo(issueId) {
    var self = this;
    return this.loadToken().then(function () {
      return self.fetch('issues/' + issueId + '/info', {});
    });
  },
  getBodyParts() {
    return require('./bodyparts.js').default;
  },
  fetch(url, data) {
    data.format = 'json';
    data.token = this.token;
    data.language = LANGUAGE;

    var fullUrl = API_URL + url + '?';
    for (var i in data) {
      fullUrl += (i) + '=' + (data[i]) + '&';
    }

    const myRequest = new Request(fullUrl);

    return fetch(myRequest).then(function (response) {
      var json = response.json();

      return json;
    });
  }
}
